import "./style.scss";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";
import DownloadSvg from "@/src/svg/applicationsPage/DownloadSvg";
import SelectDefault from "../../SelectDefault/SelectDefault";
import { FC } from "react";
import ArrowBottom from "@/src/svg/default/ArrowBottom";
import VerticalLine from "../../VerticalLine/VerticalLine";

interface ITasksFooter {
  isCurrentPage: string;
  setIsCurrentPage: React.Dispatch<React.SetStateAction<string>>;
  isSelectPagination: string;
  setIsSelectPagination: React.Dispatch<React.SetStateAction<string>>;
  actualQuantityRows: number;
}

const TasksFooter: FC<ITasksFooter> = ({
  isCurrentPage,
  setIsCurrentPage,
  isSelectPagination,
  setIsSelectPagination,
  actualQuantityRows,
}) => {
  const handleChangePagination = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsCurrentPage("1");
    setIsSelectPagination(event.target.value);
  };

  const calcActualPage = (number: number) => {
    const newPage = Number(isCurrentPage) + number;
    if (newPage > 0 && newPage <= Math.ceil(actualQuantityRows / Number(isSelectPagination))) {
      setIsCurrentPage(newPage.toString());
    }
  };

  const totalPages = Math.ceil(actualQuantityRows / Number(isSelectPagination));
  const currentPage = Number(isCurrentPage);
  const safeTotalPages = Math.max(totalPages, 1);
  const startItem = actualQuantityRows === 0 ? 0 : Number(isSelectPagination) * (currentPage - 1) + 1;
  const endItem = actualQuantityRows === 0 ? 0 : Math.min(Number(isSelectPagination) * currentPage, actualQuantityRows);

  const getPagesToShow = () => {
    const pages: number[] = [];

    if (safeTotalPages <= 5) {
      for (let i = 1; i <= safeTotalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (currentPage <= 3) {
        pages.push(2, 3, 4);
      } else if (currentPage >= safeTotalPages - 2) {
        pages.push(safeTotalPages - 3, safeTotalPages - 2, safeTotalPages - 1);
      } else {
        pages.push(currentPage - 1, currentPage, currentPage + 1);
      }

      pages.push(safeTotalPages);
    }

    return Array.from(new Set(pages)).sort((a, b) => a - b);
  };

  const pagesToShow = getPagesToShow();

  return (
    <div className="tasks-page-footer">
      <span className="pag-info">
        Showing {startItem} - {endItem} out of {actualQuantityRows}
      </span>
      <div className="tasks-page-footer-controllers">
        <div className="pagination">
          <button className="pagination-btn prev" onClick={() => calcActualPage(-1)} disabled={currentPage === 1}>
            <ArrowBottom />
          </button>
          {pagesToShow.map((page) => (
            <button key={page} className={page === currentPage ? "active" : ""} onClick={() => setIsCurrentPage(page.toString())}>
              {page}
            </button>
          ))}
          <button className="pagination-btn next" onClick={() => calcActualPage(1)} disabled={currentPage === safeTotalPages}>
            <ArrowBottom />
          </button>
        </div>

        <div className="pagination-select">
          <SelectDefault onChange={handleChangePagination} value={isSelectPagination} reverse={true}>
            <option>1</option>
            <option>5</option>
            <option>10</option>
            <option>15</option>
            <option>20</option>
            <option>50</option>
          </SelectDefault>
        </div>
        <VerticalLine />
        <BtnDefault onClick={() => console.log("Download")}>
          <p>Download</p>
          <DownloadSvg />
        </BtnDefault>
      </div>
    </div>
  );
};

export default TasksFooter;
